import React from "react";
import {UserPhone} from "./fields/UserPhone";
import {UserEmail} from "./fields/UserEmail";
import {useDispatch, useSelector} from "react-redux";
import {calc_empty_error, closeRequestPopup, SendRequest, checkbox_field_change} from "../redux/actions";

export const RequestPopup = () => {
    const dispatch = useDispatch()
    const requestPopup = useSelector(state => state.app.requestPopup)
    const requestPopupError = useSelector(state => state.app.requestPopupError)
    const sizeType = useSelector(state => state.app.sizeType)
    const fields = useSelector(state => state.app.fields)
    const departure_zone = useSelector(state => state.app.departure_zone)
    const destination_zone = useSelector(state => state.app.destination_zone)
    const advancedOptions = useSelector(state => state.app.advancedOptions)
    const requestUserPhone = useSelector(state => state.app.requestUserPhone)
    const requestUserEmail = useSelector(state => state.app.requestUserEmail)
    const processing = useSelector(state => state.app.advancedOptions.processing)
    const export_price = useSelector(state => state.app.export_price)
    const import_price = useSelector(state => state.app.import_price)
    const strahProc = useSelector(state => state.app.strahProc)
    const commision = useSelector(state => state.app.commision)
    const popup = useSelector(state => state.app.popup)
    const errorPhone = useSelector(state => state.app.requestUserPhoneError)
    const errorEmail = useSelector(state => state.app.requestUserEmailError)
    let errors = [];
    const data = {
        sizeType: sizeType,
        fields: fields,
        advancedOptions: advancedOptions,
        phone: requestUserPhone,
        email: requestUserEmail,
        departure_zone: departure_zone,
        destination_zone: destination_zone,
        popup: popup,
        export_price: export_price,
        import_price: import_price,
        strahProc: strahProc,
        commision: commision,
        processing: processing,
    }
    if (requestUserPhone === '') {
        errors.push('requestUserPhone')
    }
    if (requestUserEmail === '') {
        errors.push('requestUserEmail')
    }
    if (processing === false) {
        errors.push('requestProcessing')
    }
    if (!requestPopup) {
        return null;
    }
    console.log(data)
    const classInput = "request-popup__label_small"
    return (
        <div className="request-popup">
            <div className="request-popup__form">
                <div className="request-popup__close" onClick={() => dispatch(closeRequestPopup())}>X</div>
                <div className="request-popup__col">
                    <UserPhone/>
                </div>
                <div className="request-popup__col">
                    <UserEmail/>
                </div>
                <div className="request-popup__group">
                    <div className="request-popup__item">
                        <input className="request-popup__checkbox" id="mailing" type="checkbox" name="mailing"
                                value={advancedOptions.mailing}
                                defaultChecked={advancedOptions.mailing}
                                onChange={() => dispatch(checkbox_field_change('mailing', advancedOptions.mailing))}
                        />
                        <label
                            htmlFor="mailing"
                            className="request-popup__label_small"
                        >
                            Я согласен на получение информационных и рекламных рассылок.
                        </label>
                    </div>
                    <div className="request-popup__item">
                        <input className="request-popup__checkbox" id="processing" type="checkbox" name="processing"
                                value={advancedOptions.processing}
                                defaultChecked={advancedOptions.processing}
                                onChange={() => dispatch(checkbox_field_change('processing', advancedOptions.processing))}
                        />
                        <label
                        htmlFor="processing"
                        className={
                            classInput +
                            (!processing
                                ? " request-popup__label_error"
                                : "")
                        }
                        >
                        <div>Я согласен на обработку персональных данных в соответствии с&nbsp;
                        <a href="https://scs-aero.ru/politika-konfidentsialnosti/" target="_blank">
                            политикой конфиденциальности
                        </a>
                        .</div>
                    </label>
                    </div>
                </div>
                {
                    (errorEmail || errorPhone) && (
                        <div className="request-popup__col full">
                            <div className="request-popup__error">
                                Заполните все контактные данные. На e-mail мы пришлем подробный расчет, а по телефону
                                объясним детали.
                            </div>
                        </div>
                    )
                }
                <div className="request-popup__col full">
                    <div className="request-popup__submit btn btn__size_2 btn__orange"
                         onClick={(e) => {
                             if (requestUserPhone === '' || requestUserEmail === '' || !processing) {
                                 return dispatch(calc_empty_error(errors))
                             }
                             return dispatch(SendRequest(data));
                         }}
                    >
                        Получить точный расчет
                    </div>
                </div>
                {
                    requestPopupError && (
                        <div className="request-popup__col full">
                            <div className="request-popup__error">
                                {
                                    requestPopupError
                                }
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}